import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const navLinks = [
  { label: "關於我們", page: "/about", hash: "" },
  { label: "能量系列", page: "/products", hash: "" },
  { label: "知識專欄", page: "/knowledge", hash: "" },
  { label: "人氣精選", page: "/", hash: "#featured" },
  { label: "顧客故事", page: "/", hash: "#testimonials" },
  { label: "聯絡我們", page: "/contact", hash: "" },
];

const categories = [
  "西藏天珠",
  "天然水晶礦石",
  "翡翠玉石",
  "唐卡佛牌",
  "能量手鍊",
];

const socials = [
  { icon: "ri-instagram-line", label: "Instagram" },
  { icon: "ri-facebook-circle-line", label: "Facebook" },
  { icon: "ri-line-line", label: "LINE" },
];

export default function SiteFooter() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append("email", email);
      await fetch("https://readdy.ai/api/form/d7g69vk0ok5brd6lovvg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      // silent
    } finally {
      setSubmitting(false);
    }
  };

  const handleNavClick = (page: string, hash: string) => {
    if (page === "/" && hash) {
      if (location.pathname === "/") {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      } else {
        navigate("/");
        setTimeout(() => {
          const el = document.querySelector(hash);
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }, 400);
      }
    } else {
      navigate(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <footer id="contact" className="bg-[#1a1612]">
      <div className="max-w-7xl mx-auto px-6 md:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <button
              className="flex items-center gap-3 mb-5 cursor-pointer"
              onClick={() => { navigate("/"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/96dfeacc-3b61-4651-b117-af35c256fe09.png"
                alt="瓏靖手作能量"
                className="h-10 w-auto object-contain"
              />
              <span
                className="text-white font-semibold text-[1.0625rem] tracking-widest"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                瓏靖手作能量
              </span>
            </button>
            <p
              className="text-white/50 leading-[1.75] text-[1rem] mb-6"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              匯聚天地能量，守護你的身心靈。嚴選西藏天珠、天然水晶礦石、翡翠玉石與唐卡佛牌，傳遞東方文化的祝福與守護。
            </p>
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/50 hover:text-[#c9a96e] hover:border-[#c9a96e] transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4
              className="text-white/70 text-[1rem] font-semibold tracking-widest mb-6 uppercase"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              導覽
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.page, link.hash)}
                    className="text-white/50 hover:text-[#c9a96e] text-[1rem] transition-colors duration-300 cursor-pointer"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4
              className="text-white/70 text-[1rem] font-semibold tracking-widest mb-6 uppercase"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              商品分類
            </h4>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat}>
                  <button
                    onClick={() => handleNavClick("/", "#products")}
                    className="text-white/50 hover:text-[#c9a96e] text-[1rem] transition-colors duration-300 cursor-pointer"
                    style={{ fontFamily: "'Noto Serif TC', serif" }}
                  >
                    {cat}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4
              className="text-white/70 text-[1rem] font-semibold tracking-widest mb-6 uppercase"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              訂閱能量專欄
            </h4>
            <p
              className="text-white/50 text-[1rem] leading-[1.75] mb-5"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              訂閱我們的電子報，獲取最新能量文化知識與精選商品資訊。
            </p>
            {submitted ? (
              <div
                className="text-[#c9a96e] text-[1rem] py-3"
                style={{ fontFamily: "'Noto Serif TC', serif" }}
              >
                感謝訂閱！我們將為您帶來最新的能量文化資訊。
              </div>
            ) : (
              <form
                data-readdy-form
                id="footer-newsletter-form"
                onSubmit={handleSubscribe}
                className="flex gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="您的電子郵件"
                  required
                  className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 py-2.5 text-white text-[1rem] placeholder-white/30 focus:outline-none focus:border-[#c9a96e] transition-colors"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-[#c9a96e] text-[#1e1a16] cursor-pointer hover:bg-[#b8945a] transition-colors flex-shrink-0 disabled:opacity-60"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </form>
            )}
            <div className="mt-8 space-y-2">
              <div className="flex items-center gap-2 text-white/50 text-[1rem]">
                <i className="ri-mail-line text-[#c9a96e]"></i>
                <span style={{ fontFamily: "'Noto Serif TC', serif" }}>service@longjing.com.tw</span>
              </div>
              <div className="flex items-center gap-2 text-white/50 text-[1rem]">
                <i className="ri-line-line text-[#c9a96e]"></i>
                <span style={{ fontFamily: "'Noto Serif TC', serif" }}>LINE: @longjing</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-16 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p
              className="text-white/30 text-[1rem]"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              © 2026 瓏靖手作能量 LONGJING. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-white/30 hover:text-white/60 text-[1rem] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Serif TC', serif" }}>隱私政策</a>
              <a href="#" className="text-white/30 hover:text-white/60 text-[1rem] transition-colors cursor-pointer" style={{ fontFamily: "'Noto Serif TC', serif" }}>服務條款</a>
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-hidden border-t border-white/5">
        <p
          className="text-white/5 font-bold text-center py-4 select-none"
          style={{ fontSize: "clamp(3rem, 10vw, 8rem)", fontFamily: "'Noto Serif TC', serif", letterSpacing: "0.1em" }}
        >
          LONGJING
        </p>
      </div>
    </footer>
  );
}
